// @ts-ignore
import velocity from 'velocity-animate';

export const scrollItemToLeft = async (
    container: HTMLElement,
    target: HTMLElement,
    scrollContainer: HTMLElement,
) => {
    await velocity(
        target,
        'scroll',
        {
            axis: 'x',
            duration: 400,
            container,
            offset: -scrollContainer.offsetLeft,
        },
    );
};

export const scrollPageToElement = async (target: HTMLElement) => {
    await velocity(
        target,
        'scroll',
        {
            axis: 'y',
            duration: 600,
            offset: -70,
        },
    );
};
